import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import '../../css/InstantScreens/Instant.css';
import Spinner from 'react-bootstrap/Spinner'

import { ArrayUtils, StringUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ToastActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, PracticeStaff, PracticeAdmins, SingleScreenNavBar, Header, Input, PhoneInput, Line, PracticeLocationClients } from  '../../components'

class ClientDetailsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      info: {},
      pets: [],
      diplay_pet_inputs: false,
      name: '',
      type: '',
      age: '',
      breed: '',
      gender: '',
      add_pet_loading: false,
    }
  }

  componentDidMount() {
    let props   = this.props.location.state.props;
    let user_id = props.user_id;
    let token   = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : this.props.user.auth.token;
    this.props.practiceActions.getClientDetails(token, user_id, this.updateClientInfo);
  }

  renderClientDetailsSection = () => {
    let client_info = this.state.info;
    let pets        = this.state.pets;

    return <div className="flex-container screen-main-content" style={{ paddingTop: 20 }}>
      { this.renderClientInfo() }
      <div className='flex-container-column' style={{  }}>
        { this.renderPetInputs()  }
        { this.renderClientPets() }
      </div>
    </div>
  }

  renderClientInfo = () => {
    let client = this.state.info;
    let name   = StringUtils.displayName(client);
    let email  = client.email || '';
        email  = email.toLowerCase();
    let phone  = StringUtils.displayCodePhoneNumber(client.phone_number);

    return <div className='standard-container' style={{ width: 270, maxWidth: 270, minWidth: 270, height: 125 }}>
      <Header title='Client Info' icon='fas fa-user' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row'>
          { client.photo_url ? <img className="user-profile-profile-image" src={client.photo_url} />
          : <span className="fas fa-user-circle" style={{ fontSize: 50, color: '#e9e9e9' }}></span> }
          <div className='flex-container-column' style={{ paddingLeft: 10, justifyContent: 'flex-start' }}>
            <span style={{ fontSize: 13, color: '#575757' }}>{ name  }</span>
            <span style={{ fontSize: 13, color: 'grey' }}>{ email }</span>
            <span style={{ fontSize: 13, color: 'grey' }}>{ phone }</span>
          </div>
        </div>
      </div>
    </div>
  }

  renderClientPets = () => {
    let pets         = this.state.pets;
    let pet_rows     = this.getPetRows(pets);
    let display_none = pet_rows.length === 0;

    return <div className='standard-container' style={{ flex: 0, width: 400, maxWidth: 400, minWidth: 400 }}>
      <Header title="Client's Pets" icon='fas fa-dog'
              button_title={ this.state.diplay_pet_inputs ? '' : 'Add New Pet' }
              button_action={ () => {
                this.setState({ ...this.state, diplay_pet_inputs: true })
              }} />
      <div className='flex-container-column'>
        { pet_rows }
        { display_none ? <div style={{ textAlign: 'center', color: 'grey', fontSize: 13, padding: 30 }}>This client does not have any pets on the system</div> : null }
      </div>
    </div>
  }

  renderPetInputs = () => {
    let display = this.state.diplay_pet_inputs;
    if (!display) {
      return null;
    }

    let selected_gender = this.state.gender;

    return <div className='standard-container' style={{ flex: 0, width: 400, maxWidth: 400, minWidth: 400 }}>
      <Header title="New Pet" icon='fas fa-plus-circle' />
      <div className='flex-container-column' style={{ padding: 15 }}>
        <div className='flex-container-row' style={{ marginBottom: 10 }}>
          <Input style={{ marginRight: 5 }}
                 placeholder="Name"
                 className='instant-input-default'
                 value={this.state.name}
                 onChange={ (event) => { this.setState({ ...this.state, name: event.target.value }) }}
              />
          <Input style={{ marginLeft: 5  }}
                 placeholder="Age"
                 type="number"
                 className='instant-input-default'
                 value={this.state.age}
                 onChange={ (event) => { this.setState({ ...this.state, age: event.target.value }) }}
              />
        </div>

        <div className='flex-container-row'>
          <Input style={{ marginRight: 5 }}
                 placeholder="Type. Eg. Dog, Cat"
                 className='instant-input-default'
                 value={this.state.type}
                 onChange={ (event) => { this.setState({ ...this.state, type: event.target.value }) }}
              />
          <Input style={{ marginLeft: 5  }}
                 placeholder="Breed"
                 className='instant-input-default'
                 value={this.state.breed}
                 onChange={ (event) => { this.setState({ ...this.state, breed: event.target.value }) }}
              />
        </div>

        <div className='flex-container-column' style={{ marginTop: 10 }}>
          <span style={{ color: '#575757', fontSize: 11, marginLeft: 3, marginBottom: 5 }}>SELECT GENDER</span>
          <div className='flex-container-row'>
            <div className='color-button-border'
                 style={{ borderRadius: 5, padding: 11, paddingTop: 2, paddingBottom: 2, marginRight: 5, borderWidth: 2, borderColor: selected_gender === 'MALE' ? '#1dc2ff' : '' }}
                 onClick={ () => { this.setState({ ...this.state, gender: 'MALE' }) }}>
              <span style={{ fontSize: 13, color: '#575757' }}>Male</span>
            </div>
            <div className='color-button-border'
                 style={{ borderRadius: 5, padding: 12, paddingTop: 2, paddingBottom: 2, marginRight: 5, borderWidth: 2, borderColor: selected_gender === 'FEMALE' ? '#1dc2ff' : '' }}
                 onClick={ () => { this.setState({ ...this.state, gender: 'FEMALE' }) }}>
              <span style={{ fontSize: 13, color: '#575757' }}>Female</span>
            </div>
            <div className='color-button-border'
                 style={{ borderRadius: 5, padding: 12, paddingTop: 2, paddingBottom: 2, marginRight: 5, borderWidth: 2, borderColor: selected_gender === 'MN' ? '#1dc2ff' : '' }}
                 onClick={ () => { this.setState({ ...this.state, gender: 'MN' }) }}>
              <span style={{ fontSize: 13, color: '#575757' }}>Male Neutered</span>
            </div>
            <div className='color-button-border'
                 style={{ borderRadius: 5, padding: 12, paddingTop: 2, paddingBottom: 2, borderWidth: 2, borderColor: selected_gender === 'FS' ? '#1dc2ff' : '' }}
                 onClick={ () => { this.setState({ ...this.state, gender: 'FS' }) }}>
              <span style={{ fontSize: 13, color: '#575757' }}>Female Spayed</span>
            </div>
          </div>
        </div>

        <div className='flex-container-row' style={{ justifyContent: 'flex-end', marginTop: 15 }}>
          <div className='instant-cancel-button'
               style={{ marginRight: 5 }}
               onClick={ () => {
                 this.setState({
                   ...this.state,
                   diplay_pet_inputs: false,
                   name: '',
                   type: '',
                   age: '',
                   breed: '',
                   gender: '',
                 })
               }}>
            <span style={{ color: '#1dc2ff', fontSize: 13 }}>Cancel</span>
          </div>
          <div className='instant-join-session-button' style={{  }}
               onClick={ () => {
                 this.addPetAction();
               }}>
            { this.state.add_pet_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
            <span>Add New Pet</span>
          </div>
        </div>

      </div>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title="Client Details" />
        { this.renderClientDetailsSection() }
      </div>
    );
  }

  getPetRows = (pets) => {
    let pet_rows = [];

    pets.forEach((pet) => {
      if (pet._id) {
        let pet_details = ArrayUtils.getSingleObject(pet.patient_details);
        let name        = StringUtils.displayName(pet_details)
        let genderKeys  = {
          'MALE': 'Male',
          'FEMALE': 'Female',
          'MN': 'Male Neutered',
          'FS': 'Female Spayed',
        }
        let gender = genderKeys[pet_details.gender];

        pet_rows.push(<div key={pet._id} className='flex-container-column'>
          <div className='flex-container-row' style={{ padding: 8, paddingLeft: 15, alignItems: 'center' }}>
            { pet_details.photo_url ? <img className="user-profile-profile-image" src={pet_details.photo_url} />
            : <span className="fas fa-horse" style={{ fontSize: 50, color: '#e9e9e9' }}></span> }
            <div className='flex-container-column' style={{ flex: 1 }}>

              <div className='flex-container-row' style={{  }}>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                  <span style={{ fontSize: 10, color: '#575757' }}>NAME</span>
                  <span style={{ fontSize: 13, color: 'grey', marginTop: -2 }}>{ name }</span>
                </div>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                  <span style={{ fontSize: 10, color: '#575757' }}>AGE</span>
                  <span style={{ fontSize: 13, color: 'grey', marginTop: -2 }}>{ pet_details.age }</span>
                </div>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                  <span style={{ fontSize: 10, color: '#575757' }}>GENDER</span>
                  <span style={{ fontSize: 13, color: 'grey', marginTop: -2 }}>{ gender }</span>
                </div>
              </div>

              <div className='flex-container-row'>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                  <span style={{ fontSize: 10, color: '#575757', marginTop: 8 }}>TYPE</span>
                  <span style={{ fontSize: 13, color: 'grey', marginTop: -2 }}>{ pet_details.type }</span>
                </div>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                  <span style={{ fontSize: 10, color: '#575757', marginTop: 8 }}>BREED</span>
                  <span style={{ fontSize: 13, color: 'grey', marginTop: -2 }}>{ pet_details.breed }</span>                </div>
                <div className='flex-container-column' style={{ flex: 1, marginLeft: 15 }}>
                </div>
              </div>

            </div>
          </div>
          <Line style={{ backgroundColor: '#f5f5f5' }}/>
        </div>);

      }
    });


    return pet_rows;
  }

  addPetAction = () => {
    let client = this.state.info;
    let name   = this.state.name;
    let type   = this.state.type;
    let age    = this.state.age;
    let breed  = this.state.breed;
    let gender = this.state.gender;
    let token  = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : this.props.user.auth.token;

    if (!name || !type || !age || !breed || !gender) {
      this.props.toastActions.displayError('Name, Type, Age, Breed and Gender are required fields.');
      return;
    }

    let pet_object = {
      user_id: client._id,
      name: name,
      type: type,
      gender: gender,
      breed: breed,
      age: age,
    }

    this.props.practiceActions.addClientPet(token, pet_object, this.add_pet_success, this.add_pet_failure);
    this.setState({ ...this.state, add_pet_loading: true });
  }

  add_pet_success = () => {
    this.setState({
      ...this.state,
      diplay_pet_inputs: false,
      name: '',
      type: '',
      age: '',
      breed: '',
      gender: '',
      add_pet_loading: false,
    });

    let token  = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : this.props.user.auth.token;
    let client = this.state.info;

    this.props.practiceActions.getClientDetails(token, client._id, this.updateClientInfo);
  }

  add_pet_failure = () => {
    this.setState({ ...this.state, add_pet_loading: false });
  }

  updateClientInfo = (user_info) => {
    let client_info = user_info.info;
    let pets        = user_info.pets;
    this.setState({ ...this.state, info: client_info, pets: pets });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientDetailsScreen)
